import { DynamicForm, FormConfig } from "@components/DynamicForm/DynamicForm";
import { useNotification } from "@hooks/useNotification";
import { useQuery } from "@hooks/useQuery";
import { Button, Tabs } from "antd";
import { useNavigate } from "react-router-dom";
import { useHasAccess } from "~/Hooks/useHasAccess";
import AgenciesPageContent from "./AgenciesPageContent";
import { AgenciesPageHeading } from "./AgenciesPageHeading";
import { AgenciesNextPage } from "./AgenciesNextPage";
export const Agencies = () => {
  const navigate = useNavigate();
  const query = useQuery();
  const { openToast } = useNotification();
  const { hasRole } = useHasAccess();

  const items = [
    {
      label: "Page Heading",
      key: "agenciesPageHeading",
      children: <AgenciesPageHeading/>
    }, 
    {
      label: "Page Content",
      key: "agenciesPageContent",
      children: <AgenciesPageContent/>
    },
    {
      label: "Next Page",
      key: "agenciesNextPage",
      children: <AgenciesNextPage/>
    },
  ];

  return (
    <>
      <Tabs
        activeKey={query?.get("subActiveTab") || ""}
        items={items}
        onChange={(activeKey) => {
          navigate(`${window.location.pathname}?activeTab=${query.get("activeTab")}&subActiveTab=${activeKey}`, { replace: true });
        }}
      ></Tabs>
    </>
  );
};
